var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 2.5V6.25H4.375",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 12.5V8.75H10.625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8062 5.62499C12.4893 4.72923 11.9505 3.92836 11.2403 3.29712C10.5301 2.66588 9.67158 2.22484 8.74482 2.01515C7.81806 1.80546 6.85328 1.83395 5.94051 2.09797C5.02773 2.36199 4.19672 2.85293 3.525 3.52499L0.625 6.24999M14.375 8.74998L11.475 11.475C10.8033 12.147 9.97227 12.638 9.05949 12.902C8.14672 13.166 7.18194 13.1945 6.25518 12.9848C5.32842 12.7751 4.46988 12.3341 3.75967 11.7028C3.04946 11.0716 2.51073 10.2707 2.19375 9.37498",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset-icon.fe69a612fe17343a7aa729a1c2c51a3a.svg";
export { ForwardRef as ReactComponent };